export default __webpack_public_path__ + "static/media/sample-FP-L4.6c87811c.png";